const navConfig = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "Innovation Hub",
    path: "/innovation-hub",
  },
  {
    title: "Who We Are",
    path: "/who-we-are",
  },
  {
    title: "What We Do",
    path: "/what-we-do",
  },
  {
    title: "Events",
    path: "/our-events",
  },
  {
    title: "Resources",
    path: "/resources/infographics",
  },
  {
    title: "Contact Us",
    path: "/contact-us",
  },
];

export default navConfig;
